angular.module('FlexyBeautyApp.services')
    .factory('LegalType', ['gettextCatalog', function (gettextCatalog) {
        return {
            SOLETRADER: {
                id: "SOLETRADER",
                label: gettextCatalog.getString("un auto-entrepreneur")
            },
            SARL: {
                id: "BUSINESS",
                label: gettextCatalog.getString("une entreprise (SARL, SA, SAS, SASU, EURL...)")
            },
            from: function (legalType) {
                let entrepriseType = this.SARL;

                if (legalType && legalType === this.SOLETRADER.id) {
                    entrepriseType = this.SOLETRADER;
                }
                return entrepriseType;
            }
        };

    }]);



// WEBPACK FOOTER //
// ./js/services/views/LegalTypeConstants.js